import * as PIXI from "pixi.js";
import { GameAssets } from "../util/GameAssets";

// Define an enum for the states
export enum AutoplayButtonState {
    IDLE = "IDLE",
    STOP = "STOP",
    PASSIVE = "PASSIVE",
}

export class BetButton extends PIXI.Container {
    private isLandscape: boolean = true;
    private title: PIXI.Text;
    private betAmount: PIXI.Text;
    private sprite: PIXI.Sprite;
    public get Sprite() {
        return this.sprite;
    }
    private currentState: AutoplayButtonState = AutoplayButtonState.IDLE;

    constructor() {
        super();

        this.sprite = new PIXI.Sprite(GameAssets.textures.uiAtlas.textures["betButton.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);

        this.addChild(this.sprite);

        this.title = new PIXI.Text({
            text: "Bet",
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: 40,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2,
                },
            },
        });
        this.addChild(this.title);

        // Initialize title
        this.betAmount = new PIXI.Text({
            text: "100",
            style: {
                fill: "0xffffff",
                fontWeight: "bold",
                fontSize: 40,
                fontFamily: "UIFont",
                stroke: {
                    color: "0x000000",
                    width: 2,
                },
            },
        });
        this.betAmount.position.set(-this.betAmount.width / 2, -30);
        this.addChild(this.betAmount);
    }

    private _handleClick() {
        switch (this.currentState) {
            case AutoplayButtonState.PASSIVE:
                break;
            case AutoplayButtonState.IDLE:
                this.emit("selectBet");
                break;
        }
    }

    enable() {
        this.visible = true;
        this.sprite.interactive = true;
    }

    disable() {
        this.sprite.interactive = false;
    }

    setBet(amount: string) {
        this.betAmount.text = amount;
        this.betAmount.position.set(-this.betAmount.width / 2, -30);
    }

    onPortrait() {
        this.isLandscape = false;
        this._updatePosition();
    }

    onLandscape() {
        this.isLandscape = true;
        this._updatePosition();
    }

    private _updatePosition() {
        if (this.isLandscape) {
            this.title.position.set(
                -this.sprite.width / 2 - this.title.width,
                -this.title.height / 2,
            );
        } else {
            this.title.position.set(
                -this.title.width / 2,
                -this.sprite.height / 2 - this.title.height,
            );
        }
    }
}
